//------------ IMPORTAÇÕES ------------//
import { useContext, useEffect } from "react";
import { GruposContext } from "../../context/GruposContext";
import {
  desynchronizeProductsService,
  loadGroupsService,
  synchronizeProductService,
  updateGroupService
} from "../../services";



//------------ EXPORTAÇÃO DO MODAL EDIT GROUP ------------//
export default function ModalEditGroup() {

  //------------ HOOKS ------------//
  const {
    isOpenModalEditGroup, setIsOpenModalEditGroup,
    products, setProducts,
    idsProductsSelected, setIdsProductsSelected,
    productSearched, setProductSearched,
    groups, setGroups,
    formDataModalEditGroup, setFormDataModalEditGroup
  } = useContext(GruposContext);



  //------------ USE EFFECT PARA INICIALIZAR PRODUTOS SELECIONADOS ------------//
  // Quando o modal abre, marca os produtos que já fazem parte do grupo
  useEffect(() => {
    if (isOpenModalEditGroup && formDataModalEditGroup?.group) {
      const existingIds = formDataModalEditGroup.group.produtos.map(p => p.id);
      setIdsProductsSelected(existingIds);
    }
  }, [isOpenModalEditGroup, formDataModalEditGroup]);



  //--------------- FUNÇÃO ASSÍNCRONA SALVAR GRUPO ---------------//
  async function handleUpdateGroup() {
    const groupId = formDataModalEditGroup.group.id;

    // Atualiza nome do grupo
    await updateGroupService(groupId, formDataModalEditGroup.group.nome);

    // Produtos que já estavam sincronizados antes
    const existingProductIds = formDataModalEditGroup.group.produtos.map(p => p.id);

    // --- SINCRONIZAR PRODUTOS NOVOS ---
    for (let id of idsProductsSelected) {
      if (!existingProductIds.includes(id)) {
        await synchronizeProductService(groupId, id);
      }
    }

    // --- DESSINCRONIZAR PRODUTOS REMOVIDOS ---
    for (let id of existingProductIds) {
      if (!idsProductsSelected.includes(id)) {
        await desynchronizeProductsService(groupId, id);
      }
    }

    // --- RESETAR ESTADOS ---
    setIsOpenModalEditGroup(false);
    setIdsProductsSelected([]);
    setProductSearched("");
    setFormDataModalEditGroup({});
    await handleRefreshGroups();
  }



  //--------------- FUNÇÃO ASSÍNCRONA CARREGAR GRUPOS ---------------//
  async function handleRefreshGroups() {
    const response = await loadGroupsService();
    if (response) {
      setGroups(response.data);
    }
  }



  //--------------- FUNÇÃO TOGGLE PRODUTO ---------------//
  const toggleProduct = (id) => {
    setIdsProductsSelected(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };



  //--------------- RETORNO DO MODAL ---------------//
  return (
    <>
      {!isOpenModalEditGroup ? null : (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-surface-2 p-6 rounded-xl w-full max-w-lg border border-white/[0.08]">
            <h2 className="text-xl font-bold mb-4">Editar Grupo</h2>

            <input
              type="text"
              placeholder="Nome do Grupo"
              value={formDataModalEditGroup.group.nome}
              onChange={e =>
                setFormDataModalEditGroup({
                  ...formDataModalEditGroup,
                  group: { ...formDataModalEditGroup.group, nome: e.target.value },
                })
              }
              className="w-full mb-4 p-3 bg-surface-1 border border-white/[0.08] rounded"
            />

            <input
              type="text"
              placeholder="Buscar produto..."
              className="w-full px-3 py-2 rounded bg-surface-2 text-white border border-white/[0.08] mb-3"
              value={productSearched}
              onChange={(e) => setProductSearched(e.target.value)}
            />

            <div className="overflow-y-auto max-h-60 border border-white/[0.08] rounded bg-surface-2 text-white">
              {products
                .filter(p =>
                  p.nome.toLowerCase().includes(productSearched.toLowerCase())
                )
                .map((product) => (
                  <label key={product.id} className="flex items-center gap-2 px-4 py-2 hover:bg-surface-3">
                    <input
                      type="checkbox"
                      checked={idsProductsSelected.includes(product.id)}
                      onChange={() => toggleProduct(product.id)}
                    />
                    {product.nome} (Hotmart ID: {product.id_produto_hotmart})
                  </label>
                ))}
            </div>

            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => {
                  setIsOpenModalEditGroup(false);
                  setIdsProductsSelected([]);
                  setProductSearched("");
                  setFormDataModalEditGroup({});
                }}
                className="bg-surface-3 px-4 py-2 rounded"
              >
                Cancelar
              </button>
              <button
                onClick={handleUpdateGroup}
                className="bg-green-600 px-4 py-2 rounded"
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}